module.exports = __webpack_public_path__ + "static/media/use-case-7.ce478d67.jpg";